export const useIsStageOrDev = () => {
  const env = import.meta.env.VITE_REACT_APP_NODE_ENV || import.meta.env.MODE;
  if (
    env === "staging" ||
    env === "stage" ||
    env === "development" ||
    env === "dev"
  ) {
    return true;
  }
  // Production builds resolve MODE to "production" regardless of target env, so
  // fall back to the host: prod is mfe.observe.tech, staging is
  // mfe.staging.observe.tech (matches DebugBadge's isDebugEnvironment).
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return true;
    if (host.endsWith("staging.observe.tech")) return true;
  }
  return false;
};
